/**
 * Jaron, Nov 1 (13443992736): "when someone does not press Apply, the number
 * on the customer report shows the wrong numbers... make sure the total cost
 * shows as NA if Apply is not pressed".
 *
 * Applied = `payment_is_applied`, set only by Payment Method's Apply and
 * cleared by Unlock. That field exists since 2026-04-28, so it cannot speak for
 * older deals: 1,015 signed customers don't have it (Nov 1 backup). Any
 * signature therefore keeps the figure the document has always shown (V67).
 *
 * Display only: no calculation, seed or write reads this.
 */
import { hasAnySignature } from './signingFlowV2'

export const TOTAL_PENDING_LABEL = 'N/A'

export const totalCostPendingApply = (
  customer: Readonly<Record<string, unknown>> | null | undefined,
  isMain: boolean,
): boolean =>
  isMain &&
  !!customer &&
  !customer['payment_is_applied'] &&
  !hasAnySignature(customer)
